import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { userTypes } from "../../data/userTypes";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  riders: {
    data: [],
    meta: {
      total: 0,
    },
  },
  singleRider: null,
};

// TODO: fetch all the ridex riders
export const fetchRiders = createAsyncThunk(
  "fetchRiders/riders",
  async (
    { enqueueSnackbar, limit, page = 0, type, search, filter },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.get(`users`, {
        params: {
          user_type: userTypes.rider,
          limit,
          page: page + 1,
          type,
          ...(filter && { status: filter.status }),
          ...(search !== "" && {
            search,
          }),
        },
      });
      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: fetch the ridex rider
export const fetchSingleRider = createAsyncThunk(
  "fetchSingleRider/riders",
  async ({ enqueueSnackbar, id }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`users/get-user/${id}`);
      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create the ridex riders
export const createRider = createAsyncThunk(
  "createRider/riders",
  async ({ enqueueSnackbar, data, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`riders`, data);
      return {
        data: response.data.data,
        meta: {
          total: response.data.data.length,
        },
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update vehicles
export const updateRiderVehicle = createAsyncThunk(
  "updateRiderVehicle/riders",
  async ({ enqueueSnackbar, data, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`riders/vehicles/${id}`, data);
      return {
        data: response.data.data,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete the ridex riders
export const deleteRider = createAsyncThunk(
  "deleteRider/riders",
  async ({ enqueueSnackbar, handleClose, userId }, thunkApi) => {
    try {
      const response = await axiosInstance.delete(
        `delete-user-account/${userId}`
      );

      return {
        data: response.data.data,
        meta: {
          total: response.data.data.length,
        },
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const verifyAvatar = createAsyncThunk(
  "verifyAvatar/verification",
  async ({ enqueueSnackbar, data, onClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`riders/verify/avatar`, data);

      return {
        data: response.data.data.profile,
        enqueueSnackbar,
        onClose,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const verifyRider = createAsyncThunk(
  "verifyRider/verification",
  async ({ enqueueSnackbar, data, onClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`auth/verify-user`, data);

      return {
        data: response.data.data.items,
        enqueueSnackbar,
        onClose,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const verifyDocs = createAsyncThunk(
  "verifyDocs/verification",
  async ({ enqueueSnackbar, id, data, onClose }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(
        `riders/verify/documents/${id}`,
        data
      );
      return {
        data: response.data.data,
        enqueueSnackbar,
        onClose,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const riderslice = createSlice({
  name: "rider",
  initialState,
  reducers: {
    resetSingleRider: (state) => {
      state.singleRider = null;
    },
  },
  extraReducers: (builder) => {
    // TODO: fetch ridex riders
    builder.addCase(fetchRiders.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchRiders.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.riders = action.payload;
    });

    builder.addCase(fetchRiders.rejected, (state, action) => {
      state.fetchLoading = false;
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: fetch single rider
    builder.addCase(fetchSingleRider.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchSingleRider.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.singleRider = action.payload;
    });

    builder.addCase(fetchSingleRider.rejected, (state, action) => {
      state.fetchLoading = false;
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: create rider
    builder.addCase(createRider.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createRider.fulfilled, (state, action) => {
      state.isLoading = false;
      state.riders.data = [action.payload, ...state.riders.data];
      action.payload.enqueueSnackbar("Rider is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createRider.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: update rider vehicle
    builder.addCase(updateRiderVehicle.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateRiderVehicle.fulfilled, (state, action) => {
      state.isLoading = false;
      state.singleRider.vehicles = state.singleRider.vehicles.map((vehicle) => {
        if (vehicle.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return vehicle;
        }
      });
      action.payload.enqueueSnackbar(
        "Rider's vehicle is updated successfully.",
        {
          variant: "success",
        }
      );
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateRiderVehicle.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: delete rider
    builder.addCase(deleteRider.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteRider.fulfilled, (state, action) => {
      state.isLoading = false;
      state.riders.data = state.riders.data.filter(
        (rider) => rider?.id !== action.payload.data.id
      );
      state.riders.meta.total = state.riders.meta.total - 1;
      action.payload.enqueueSnackbar("Rider is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteRider.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    builder.addCase(verifyAvatar.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(verifyAvatar.fulfilled, (state, action) => {
      state.isLoading = false;
      state.singleRider = {
        ...state.singleRider,
        profile: action.payload.data,
      };

      action.payload.onClose && action.payload.onClose();

      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar("Profile picture verified successfully");
    });

    builder.addCase(verifyAvatar.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar(
          JSON.stringify(action.payload.error.message || action.payload.error),
          {
            variant: "error",
          }
        );
    });

    builder.addCase(verifyDocs.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(verifyDocs.fulfilled, (state, action) => {
      state.isLoading = false;
      state.singleRider = {
        ...state.singleRider,
        documents: state.singleRider.documents.map((doc) => {
          if (doc.id === action.payload.data.id) {
            return action.payload.data;
          } else {
            return doc;
          }
        }),
      };
      action.payload.onClose && action.payload.onClose();
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar("Issue is submitted successfully");
    });

    builder.addCase(verifyDocs.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar(
          JSON.stringify(action.payload.error.message || action.payload.error),
          {
            variant: "error",
          }
        );
    });

    builder.addCase(verifyRider.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(verifyRider.fulfilled, (state, action) => {
      state.isLoading = false;
      state.singleRider = action.payload.data;
      action.payload.onClose && action.payload.onClose();
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar("Rider is verified successfully", {
          variant: "success",
        });
    });

    builder.addCase(verifyRider.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar(
          JSON.stringify(action.payload.error.message || action.payload.error),
          {
            variant: "error",
          }
        );
    });
  },
});

export default riderslice.reducer;

export const { resetSingleRider } = riderslice.actions;
